

































import {Component, Model, Prop, Vue, Watch} from 'vue-property-decorator';
import NodesTreeAddDialog from './NodesTreeAddDialog.vue';
import NodesTreeRemoveDialog from './NodesTreeRemoveDialog.vue';
import NodesTreeEditDialog from '@c/nodesTree/NodesTreeEditDialog.vue';
import {findNodeById} from '@u/nodeUtils';
import SimpleDialog from '@c/SimpleDialog.vue';
import {NodeData} from '@/system/nodes/interfaces';

@Component({
  components: {
    NodesTreeAddDialog,
    NodesTreeRemoveDialog,
    NodesTreeEditDialog,
    SimpleDialog,
  },
})
export default class NodesTree extends Vue {
  // Режим редактирования
  @Prop({required: false, default: true})
  edit!: boolean;

  // Список узлов дерева
  @Prop({required: true, type: Array})
  items!: NodeData[];

  // Строка поиска
  @Prop({required: false, type: String, default: ''})
  search!: string;

  //
  @Prop({required: true})
  selNodesInDB!: string[];

  @Watch('items')
  onItemsChanged(newValue: any, prevValue: any) {
    //обновляем selectedNode по новым данным, если он был выбран
    if (this.selectedNode) {
      this.selectedNode = findNodeById(this.selectedNode.id, this.items);

      if (this.selectedNode && !this.openItems.includes(this.selectedNode))
        this.openItems.push(this.selectedNode);
    }
    if (!prevValue.length) this.openAllNodes();
  }

  // Ключ для перерисовки элементов дерева
  // Необходимо для обновления css классов элементов дерева при установке locked
  key = 0;

  selected: string[] = [];

  // Модель выбранного узла
  @Model('change') _selectedNode!: NodeData | null;

  get selectedNode() {
    return this._selectedNode;
  }

  set selectedNode(newValue: NodeData | null) {
    this.$emit('change', newValue);
  }

  // Список активных элементов
  activeItems: NodeData[] = [];

  // Список открытых элементов
  openItems: NodeData[] = [];

  created() {
    this.selected = this.selNodesInDB;
    if (this.selectedNode) {
      this.openAllNodes();
      this.activeItems = [this.selectedNode];
    }
  }

  // Действия при обновлении активного элемента
  onUpdateActive() {
    this.$emit('selected', this.selected);
  }

  // Открыть все узлы
  openAllNodes() {
    const open: NodeData[] = [];
    this.items.forEach(node => {
      const stack = [node];
      while (stack.length) {
        const x = stack.pop();
        if (x && x.children) {
          open.push(x);
          x.children.forEach(c => stack.push(c));
        }
      }
    });
    this.openItems = [...open];
  }
}
